import { browserName, isAndroid, isIOS } from 'react-device-detect'
import { browserHistory } from 'react-router'

export const checkDevice = () => {
    if (isIOS) {
        browserHistory.push('/ios')
    } else if (isAndroid) {
        browserHistory.push('/android')
    } else if (browserName === 'IE') { //the 'isIE' function doesn't work
        browserHistory.push('/unsupported-browser')
    }
}

